import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { tabsAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tabsAnatomy.keys);

const baseStyle = definePartsStyle({
  tab: {
    fontWeight: 'medium'
  },
  tabpanel: {
    padding: 0
  }
});

const sidenav = definePartsStyle(props => {
  const { colorScheme } = props;

  return {
    tab: {
      color: 'utility.700',
      lineHeight: 5,
      justifyContent: 'start',
      textAlign: 'left',
      px: 'sidebarPx',
      py: 1.5,

      _disabled: {
        color: 'initial'
      },

      _hover: {
        bgColor: `${colorScheme}.50`,
        color: 'utility.800',

        _disabled: {
          bgColor: 'initial',
          color: 'initial'
        }
      },

      _selected: {
        bgColor: `${colorScheme}.100`,
        color: 'utility.900'
      },

      _dark: {
        color: 'whiteAlpha.600',

        _hover: {
          bgColor: 'whiteAlpha.100'
        },

        _selected: {
          bgColor: 'whiteAlpha.200'
        }
      }
    }
  };
});

export const tabsTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  variants: {
    'soft-rounded': baseStyle,
    'solid-rounded': baseStyle,
    sidenav: sidenav
  }
});
